import Toast from '../../components/toast/toast';

class Barcode {
	constructor(el) {
		this.el = el;
		this.numberEl = this.el.querySelector('span');

		this.init();
	}

	init() {
		if (!this.numberEl) return;

		this.el.addEventListener('click', () => {
			const text = this.numberEl.textContent.trim();

			navigator.clipboard
				.writeText(text)
				.then(() => {
					Toast.open('toast-copy-text');
				})
				.catch(() => {
					alert('Не удалось скопировать текст');
				});
		});
	}
}

document.querySelectorAll('[data-barcode]').forEach((el) => new Barcode(el));

export default Barcode;
